<template>
  <v-container fluid grid-list-xl class="trip-wizard">
    
    <transition name="fade-up" mode="out-in" appear>
      <v-layout column v-if="step == 'current_style'" key="step_current_style">

        <v-flex class="pb-0">
          <v-layout row>
            <v-flex xs12 class="text-xs-center">
              <h1>How would you describe your personal style?</h1>
            </v-flex>
          </v-layout>
          <v-layout row justify-center align-center my-0>
            <v-flex shrink style="min-height: 50px;" class="pt-2 pb-0">
              <span class="">*Select all that apply</span>
            </v-flex>
          </v-layout>
        </v-flex>

        <v-flex my-1>
          <v-layout row wrap justify-center class="ma-0 pa-0">
            <v-flex
              v-for="(style, styleIndex) in options.current_style"
              :key="'style-' + style.key"
              :data-index="styleIndex"
              xs12
              sm4
              md3
              lg2
              class="box-container pa-1 stylecurrent-container"
            >
              <v-hover>
                <div 
                  slot-scope="{ hover }"
                  class="box-subcontainer pa-2"
                  :class="{'hovering':hover, 'selected':(selections.current_style && selections.current_style.indexOf(style.key) >= 0)}"
                  @click="toggleValue('current_style', style.key)"
                >
                  <div 
                    class="style-img-container" 
                    :style="{backgroundImage: 'url(' + cdn + style.image + ')'}"
                  >
                  </div>
                  <div class="label-container font-weight-bold py-2">{{ style.label }}</div>
                </div> 
              </v-hover>
            </v-flex>
          </v-layout>
        </v-flex>

      </v-layout>



      <v-layout column v-if="step == 'colors_avoid'" key="step_colors_avoid">

        <v-flex class="pb-0">
          <v-layout row>
            <v-flex xs12 class="text-xs-center">
              <h1>Which colors do you prefer <u>not</u> to wear?</h1>
            </v-flex>
          </v-layout>
          <v-layout row justify-center align-center my-0>
            <v-flex shrink style="min-height: 50px;" class="pt-2 pb-0">
              <span>*Select all that apply</span>
            </v-flex>
          </v-layout>
        </v-flex>

        <v-flex my-1>
          <v-layout row justify-center class="ma-0 pa-0">
            <v-flex class="ma-0 pa-0" style="max-width: 700px;">
              <v-layout row wrap justify-center class="ma-0 pa-0">
                <v-flex
                  v-for="(color, colorIndex) in options.colors_avoid"
                  :key="'color-' + color.key"
                  :data-index="colorIndex"
                  class="color-container"
                  
                >
                  <v-hover>
                    <div 
                      slot-scope="{ hover }"
                      class="color-subcontainer" 
                      :style="{backgroundColor: color.color}"
                      :class="{['color-' + color.key]: true,'hovering':hover, 'selected':(selections.colors_avoid && selections.colors_avoid.indexOf(color.key) >= 0)}"

                      @click="toggleValue('colors_avoid',color.key)"
                    >
                      <div class="selected-background">
                        
                      </div>
                      <div class="hover-background"></div>
                    </div>
                  </v-hover>
                  <div class="text-container">{{ color.key.charAt(0).toUpperCase() + color.key.substring(1) }}</div>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>


      <v-layout column v-if="step == 'patterns_avoid'" key="step_patterns_avoid">

        <v-flex class="pb-0">
          <v-layout row>
            <v-flex xs12 class="text-xs-center">
              <h1>Which patterns do you prefer <u>not</u> to wear?</h1>
            </v-flex>
          </v-layout>
          <v-layout row justify-center align-center my-0>
            <v-flex shrink style="min-height: 50px;" class="pt-2 pb-0">
              <span class="">*Select all that apply</span>
            </v-flex>
          </v-layout>
        </v-flex>

        <v-flex my-1>
          <v-layout row wrap justify-center class="ma-0 pa-0">
            <v-flex
              v-for="(pattern, patternIndex) in options.patterns_avoid"
              :key="'pattern-' + pattern.key"
              :data-index="patternIndex"
              xs6
              sm4
              md3
              lg2
              class="box-container pa-1"
            >
              <v-hover>
                <div 
                  slot-scope="{ hover }"
                  class="box-subcontainer pa-2"
                  :class="{'hovering':hover, 'selected':(selections.patterns_avoid && selections.patterns_avoid.indexOf(pattern.key) >= 0)}"
                  @click="toggleValue('patterns_avoid', pattern.key)"
                >
                  <div 
                    class="img-container" 
                    :style="{backgroundImage: 'url(' + cdn + pattern.image + ')'}"
                  >
                  </div>
                  <div class="label-container font-weight-bold py-2">{{ pattern.label }}</div>
                </div> 
              </v-hover>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>


      <v-layout column v-if="step == 'necklines'" key="step_necklines">

        <v-flex class="pb-0">
          <v-layout row>
            <v-flex xs12 class="text-xs-center">
              <h1>My preferred necklines include...</h1>
            </v-flex>
          </v-layout>
          <v-layout row justify-center align-center my-0>
            <v-flex shrink style="min-height: 50px;" class="pt-2 pb-0">
              <span class="">*Select all that apply</span>
            </v-flex>
          </v-layout>
        </v-flex>

        <v-flex my-1>
          <v-layout row wrap justify-center class="ma-0 pa-0">
            <v-flex
              v-for="(neckline, necklineIndex) in options.necklines"
              :key="'neckline-' + neckline.key"
              :data-index="necklineIndex"
              xs6
              sm4
              md3
              lg2
              class="box-container pa-1"
            >
              <v-hover>
                <div 
                  slot-scope="{ hover }"
                  class="box-subcontainer pa-2"
                  :class="{'hovering':hover, 'selected':(selections.necklines && selections.necklines.indexOf(neckline.key) >= 0)}"
                  @click="toggleValue('necklines', neckline.key)"
                >
                  <div 
                    class="img-container" 
                    :style="{backgroundImage: 'url(' + cdn + neckline.image + ')'}"
                  >
                  </div>
                  <div class="label-container font-weight-bold py-2">{{ neckline.label }}</div>
                </div> 
              </v-hover>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>



      <v-layout column v-if="step == 'top_half_fit'" key="step_top_half_fit">

        <v-flex class="pb-0">
          <v-layout row>
            <v-flex xs12 class="text-xs-center">
              <h1>I like my tops to fit...</h1>
            </v-flex>
          </v-layout>
          <v-layout row justify-center align-center my-0>
            <v-flex shrink style="min-height: 50px;" class="pt-2 pb-0">
              <span class="">*Select all that apply</span>
            </v-flex>
          </v-layout>
        </v-flex>

        <v-flex my-1>
          <v-layout row wrap justify-center class="ma-0 pa-0">
            <v-flex
              v-for="(topHalf, topHalfIndex) in options.top_half_fit"
              :key="'topHalf-' + topHalf.key"
              :data-index="topHalfIndex"
              xs6
              sm4
              md3
              lg2
              class="box-container pa-1 styletop-container"
            >
              <v-hover>
                <div 
                  slot-scope="{ hover }"
                  class="box-subcontainer pa-2"
                  :class="{'hovering':hover, 'selected':(selections.top_half_fit && selections.top_half_fit.indexOf(topHalf.key) >= 0)}"
                  @click="toggleValue('top_half_fit', topHalf.key)"
                >
                  <div 
                    class="img-container" 
                    :style="{backgroundImage: 'url(' + cdn + topHalf.image + ')'}"
                  >
                  </div>
                  <div class="label-container font-weight-bold py-2">{{ topHalf.label }}</div>
                </div> 
              </v-hover>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>



      <v-layout column v-if="step == 'sleeve_preference'" key="step_sleeve_preference">

        <v-flex class="pb-0">
          <v-layout row>
            <v-flex xs12 class="text-xs-center">
              <h1>My shirt-sleeve preference is...</h1>
            </v-flex>
          </v-layout>
          <v-layout row justify-center align-center my-0>
            <v-flex shrink style="min-height: 50px;" class="pt-2 pb-0">
              <span class="">*Select all that apply</span>
            </v-flex>
          </v-layout>
        </v-flex>

        <v-flex my-1>
          <v-layout row wrap justify-center class="ma-0 pa-0">
            <v-flex
              v-for="(sleeve, sleeveIndex) in options.sleeve_preference"
              :key="'sleeve-' + sleeve.key"
              :data-index="sleeveIndex"
              xs6
              sm4
              md3
              lg2
              class="box-container pa-1"
            >
              <v-hover>
                <div 
                  slot-scope="{ hover }"
                  class="box-subcontainer pa-2"
                  :class="{'hovering':hover, 'selected':(selections.sleeve_preference && selections.sleeve_preference.indexOf(sleeve.key) >= 0)}"
                  @click="toggleValue('sleeve_preference', sleeve.key)"
                >
                  <div 
                    class="img-container" 
                    :style="{backgroundImage: 'url(' + cdn + sleeve.image + ')'}"
                  >
                  </div>
                  <div class="label-container font-weight-bold py-2">{{ sleeve.label }}</div>
                </div> 
              </v-hover>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>



      <v-layout column v-if="step == 'pant_fit'" key="step_pant_fit">

        <v-flex class="pb-0">
          <v-layout row>
            <v-flex xs12 class="text-xs-center">
              <h1>I like the style of my pants...</h1>
            </v-flex>
          </v-layout>
          <v-layout row justify-center align-center my-0>
            <v-flex shrink style="min-height: 50px;" class="pt-2 pb-0">
              <span class="">*Select all that apply</span>
            </v-flex>
          </v-layout>
        </v-flex>

        <v-flex my-1>
          <v-layout row wrap justify-center class="ma-0 pa-0">
            <v-flex
              v-for="(pant, pantIndex) in options.pant_fit"
              :key="'pant-' + pant.key"
              :data-index="pantIndex"
              xs6
              sm4
              md3
              lg2
              class="box-container pa-1 stylepant-container"
            >
              <v-hover>
                <div 
                  slot-scope="{ hover }"
                  class="box-subcontainer pa-2"
                  :class="{'hovering':hover, 'selected':(selections.pant_fit && selections.pant_fit.indexOf(pant.key) >= 0)}"
                  @click="toggleValue('pant_fit', pant.key)"
                >
                  <div 
                    class="img-container" 
                    :style="{backgroundImage: 'url(' + cdn + pant.image + ')'}"
                  >
                  </div>
                  <div class="label-container font-weight-bold py-2">{{ pant.label }}</div>
                </div> 
              </v-hover>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>



      <v-layout column v-if="step == 'dress_style'" key="step_dress_style">

        <v-flex class="pb-0">
          <v-layout row>
            <v-flex xs12 class="text-xs-center">
              <h1>I feel comfortable in these dress styles...</h1>
            </v-flex>
          </v-layout>
          <v-layout row justify-center align-center my-0>
            <v-flex shrink style="min-height: 50px;" class="pt-2 pb-0">
              <span class="">*Select all that apply</span>
            </v-flex>
          </v-layout>
        </v-flex>

        <v-flex my-1>
          <v-layout row wrap justify-center class="ma-0 pa-0">
            <v-flex
              v-for="(dress, dressIndex) in options.dress_style"
              :key="'dress-' + dress.key"
              :data-index="dressIndex"
              xs6
              sm4
              md3
              lg2
              class="box-container pa-1 styledress-container"
            >
              <v-hover>
                <div 
                  slot-scope="{ hover }"
                  class="box-subcontainer pa-2"
                  :class="{'hovering':hover, 'selected':(selections.dress_style && selections.dress_style.indexOf(dress.key) >= 0)}"
                  @click="toggleValue('dress_style', dress.key)"
                >
                  <div 
                    class="img-container" 
                    :style="{backgroundImage: 'url(' + cdn + dress.image + ')'}"
                  >
                  </div>
                  <div class="label-container font-weight-bold py-2">{{ dress.label }}</div>
                </div> 
              </v-hover>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>


      <v-layout column v-if="step == 'items_avoid'" key="step_items_avoid">

        <v-flex class="pb-0">
          <v-layout row>
            <v-flex xs12 class="text-xs-center">
              <h1>I prefer <u>not</u> to wear...</h1>
            </v-flex>
          </v-layout>
          <v-layout row justify-center align-center my-0>
            <v-flex shrink style="min-height: 50px;" class="pt-2 pb-0">
              <span class="">*Select all that apply</span>
            </v-flex>
          </v-layout>
        </v-flex>

        <v-flex my-1>
          <v-layout row wrap justify-center class="ma-0 pa-0">
            <v-flex
              v-for="(itemAvoid, itemAvoidIndex) in options.items_avoid"
              :key="'itemAvoid-' + itemAvoid.key"
              :data-index="itemAvoidIndex"
              xs6
              sm4
              md3
              lg2
              class="box-container pa-1"
            >
              <v-hover>
                <div 
                  slot-scope="{ hover }"
                  class="box-subcontainer pa-2"
                  :class="{'hovering':hover, 'selected':(selections.items_avoid && selections.items_avoid.indexOf(itemAvoid.key) >= 0)}"
                  @click="toggleValue('items_avoid', itemAvoid.key)"
                >
                  <div 
                    class="img-container" 
                    :style="{backgroundImage: 'url(' + cdn + itemAvoid.image + ')'}"
                  >
                  </div>
                  <div class="label-container font-weight-bold py-2">{{ itemAvoid.label }}</div>
                </div> 
              </v-hover>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>



      <v-layout column v-if="step == 'areas_conceal'" key="step_areas_conceal">

        <v-flex class="pb-0">
          <v-layout row>
            <v-flex xs12 class="text-xs-center">
              <h1>Conceal my...</h1>
            </v-flex>
          </v-layout>
          <v-layout row justify-center align-center my-0>
            <v-flex shrink style="min-height: 50px;" class="pt-2 pb-0">
              <span class="">*Select all that apply</span>
            </v-flex>
          </v-layout>
        </v-flex>

        <v-flex my-1>
          <v-layout row wrap justify-center class="ma-0 pa-0" :style="{margin: ($vuetify.breakpoint.lgAndUp ? '0px 16.65% !important' : '0 0')}">
            <v-flex
              v-for="(conceal, concealIndex) in options.areas_conceal"
              :key="'conceal-' + conceal.key"
              :data-index="concealIndex"
              xs6
              sm4
              md3
              class="box-container pa-1"
            >
              <v-hover>
                <div 
                  slot-scope="{ hover }"
                  class="box-subcontainer pa-2"
                  :class="{'hovering':hover, 'selected':(selections.areas_conceal && selections.areas_conceal.indexOf(conceal.key) >= 0)}"
                  @click="toggleValue('areas_conceal', conceal.key)"
                >
                  <div 
                    class="img-container" 
                    :style="{backgroundImage: 'url(' + cdn + conceal.image + ')'}"
                  >
                  </div>
                  <div class="label-container font-weight-bold py-2">{{ conceal.label }}</div>
                </div> 
              </v-hover>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>



    </transition>
  
  </v-container>
</template>


<script>
import styleOptions from '@/consts/styleOptions';
import styleFields from '@/consts/styleFields';

export default {
  name: 'Style',
  props: {
    reverse: Boolean
  },
  data () {
    return {
      step: (this.reverse ? 'areas_conceal' : 'current_style'),

      selections: JSON.parse(JSON.stringify(this.$store.getters.style)),
      
      wizard: [
        'current_style',
        'colors_avoid',
        'patterns_avoid',
        'necklines',
        'top_half_fit',
        'sleeve_preference',
        'pant_fit',
        'dress_style',
        'items_avoid',
        'areas_conceal'
      ],

      options: styleOptions
    }
  },
  mounted: function() {
    this.toggleWizardNextPrev();
  },
  watch: {
    'selections': {
      handler: function(newVal, oldVal) {

        this.toggleWizardNextPrev();
        this.$emit('on-update', this.selections);
      },
      deep: true
    },
    'step': function(newVal, oldVal) {
      this.toggleWizardNextPrev();
    },
  },
  computed: {
    cdn: function() {
      return this.$root.cdn;
    },
    user: function() {
      return this.$store.getters.user;
    },
    stateStyle: function() {
      return this.$store.getters.style;
    },
    styleFirst: function() {
      return this.$store.getters.wizardNavigator.styleFirst;
    },
    nextDisabled: function() {

      if( this.step == 'current_style' ||
          this.step == 'necklines' ||
          this.step == 'top_half_fit' ||
          this.step == 'sleeve_preference' ||
          this.step == 'pant_fit' ||
          this.step == 'dress_style' ||
          this.step == 'areas_conceal'
      )
      {
        if(this.selections && this.selections[ this.step ] && this.selections[ this.step ].length) return false;
        return true;
      }

    },
    previousDisabled: function() {
      if(this.styleFirst && this.step == 'current_style') return true;
      return false;
    }
  },
  methods: {
    toggleWizardNextPrev: function() {
      this.$nextTick( () => {
        this.$store.commit('setWizardNextDisabled', this.nextDisabled);
        this.$store.commit('setWizardPrevDisabled', this.previousDisabled);
      });
    },

    nextStep: function() {
      if(this.nextDisabled) return;
      let cur_index = this.wizard.indexOf(this.step);


      //Build Post/Patch object
      let update_data = JSON.parse(JSON.stringify(this.selections));
      for(let i = 0; i < Object.keys( styleFields ).length; i++) {
        let key = Object.keys( styleFields )[i];
        if(!this.selections || !this.selections[key]) continue;

        //Need to update any set to 'no_preference' with all options instead
        if(this.selections[key].indexOf('no_preference') >= 0) {
          let arr = [];
          for(let i2 = 0; i2 < this.options[key].length; i2++) {
            if(this.options[key][i2].key != 'no_preference') arr.push(this.options[key][i2].key);
          }
          update_data[key] = arr;
        }

        //Need to update any set to 'none' with No options instead
        if(this.selections[key].indexOf('none') >= 0) {
          update_data[key] = ['none'];
        }
      }

      this.$http.post('users/' + this.user.id + '/style', update_data)
        .then(response => {
          this.$store.commit('setStyle', response.data);
        })
        .catch(error => {
          console.log(error);
        });


      if((cur_index + 1) == this.wizard.length) {
        this.$emit('on-complete', this.selections);
        return;
      }

      this.step = this.wizard[ (cur_index + 1) ];
    },
    previousStep: function() {
      if(this.previousDisabled) return;
      let cur_index = this.wizard.indexOf(this.step);

      if(cur_index === 0) {
        this.$emit('on-cancel');
        return;
      }

      this.step = this.wizard[ (cur_index - 1) ];
    },
    lastStep: function() {
      this.step = this.wizard[ this.wizard.length - 1 ];
    },
    toggleValue: function(key, value) {
      if(!this.selections[key]) this.$set(this.selections, key, []);
      let val_index = this.selections[key].indexOf(value);
      
      if(val_index >= 0) {
        this.selections[key].splice(val_index,1);
        return;
      }

      if(value == 'no_preference') {
        this.$set(this.selections, key, ['no_preference']);
      } else if(value == 'none') {
        this.$set(this.selections, key, ['none']);
      } else {
        //If no preference is set, remove it
        let nopref_index = this.selections[key].indexOf('no_preference');
        if(nopref_index >= 0) this.selections[key].splice(nopref_index, 1);

        //If none is set, remove it
        let none_index = this.selections[key].indexOf('none');
        if(none_index >= 0) this.selections[key].splice(none_index, 1);

        this.selections[key].push(value);
      }
    },

    /*updateSelections: function() {
      let sel = JSON.parse(JSON.stringify(this.$store.getters.style));
      let keys = Object.keys(sel);

      for(let key of keys) {

        let allSelected = true;
        let hasNoPref = false;
        for(let i = 0; i < this.options[ key ].length; i++) {
          let opt = this.options[key][i];
          if(opt.key == 'no_preference') {
            console.log(key + ' has no preference option');
            hasNoPref = true;
          } else if(sel[key].indexOf(opt.key) < 0) {
            console.log(key + ' not all selected (' + opt.key + ')');
            allSelected = false;
          }
        }

        if(hasNoPref && allSelected) sel[key] = ['no_preference'];
      }

      this.selections = sel;
    }*/
  }
}
</script>